import React from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import _ from 'underscore';
import SessionStore from 'stores/SessionStore';
import USER_TYPES from 'constants/UserTypes';

export default class MapView extends React.Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.markers = {};
    this.directionsRenderer = null;
    this.trafficLayer = null;
  }

  componentDidMount() {
    if (this.props.directions) {
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        directions: this.props.directions,
      });
    }
    this.map = new google.maps.Map(
      document.getElementById(this.props.id),
      this.getMapOptions(),
    );

    if (this.props.fitMarkers) {
      const bounds = new google.maps.LatLngBounds();
      this.props.markers.forEach((m) => {
        bounds.extend(m.position);
      });
      this.map.fitBounds(bounds);
    }

    if (this.props.directions) {
      this.directionsRenderer.setMap(this.map);
    }

    if (this.props.showTraffic) {
      this.trafficLayer = new google.maps.TrafficLayer();
      this.trafficLayer.setMap(this.map);
    }
  }

  componentWillUnmount() {
    _.values(this.markers).forEach((marker) => {
      marker.setMap(null);
    });
    this.markers = {};

    if (this.trafficLayer) {
      this.trafficLayer.setMap(null);
      this.trafficLayer = null;
    }

    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null);
      this.directionsRenderer = null;
    }

    this.map = null;
  }

  componentDidUpdate(prevProps) {
    const centerChanged = !deepEqual(
      prevProps.initCenter,
      this.props.initCenter,
    );
    const zoomChanged = prevProps.initZoom !== this.props.initZoom;

    if (centerChanged || zoomChanged) {
      this.map.setOptions(this.getMapOptions());
    }

    if (this.props.markers.length) {
      this.props.markers.forEach((m) => {
        const marker = this.markers[m.id];
        if (!marker) {
          this.markers[m.id] = new google.maps.Marker({
            map: this.map,
            icon: m.icon,
            position: m.position,
          });

          const infoWindow = new google.maps.InfoWindow({
            content: m.info,
          });
          const { _type } = SessionStore.getUser();
          if (_type?.toLowerCase() !== USER_TYPES.SHIPPER) {
            this.markers[m.id].addListener('click', () => {
              infoWindow.open(this.map, this.markers[m.id]);
            });
          }
        } else {
          this.markers[m.id].setPosition(m.position);
        }
      });

      _.keys(this.markers).forEach((id) => {
        if (_.findWhere(this.props.markers, { id }) === undefined) {
          this.markers[id].setMap(null);
          delete this.markers[id];
        }
      });
    }
  }

  getMapOptions() {
    return {
      center: new google.maps.LatLng(
        this.props.initCenter[0],
        this.props.initCenter[1],
      ),
      zoom: this.props.initZoom,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
    };
  }

  render() {
    return <div id={this.props.id} style={{ height: this.props.height }} />;
  }
}

MapView.propTypes = {
  id: PropTypes.string.isRequired,
  initCenter: PropTypes.array,
  initZoom: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  directions: PropTypes.object,
  markers: PropTypes.array,
  fitMarkers: PropTypes.bool,
  showTraffic: PropTypes.bool,
};

MapView.defaultProps = {
  initCenter: [34.0383912, -118.2874809],
  initZoom: 11,
  height: '100%',
  directions: null,
  markers: [],
  fitMarkers: false,
  showTraffic: false,
};
